export const defaultAttributes = {
  blockId: {
    type: 'string',
    default: '',
  },
  columnSize: {
    type: 'object',
    default: {
      xs: 0,
      sm: 12,
      md: 0,
      lg: 0,
      xl: 0,
      xxl: 0,
    },
  },
  label: {
    type: 'string',
    default: '',
  },
  enableFocusableIcon: {
    type: 'boolean',
    default: true,
  },
};
